export default {"src":"/_next/static/media/icon-choice.72c11ea5.svg","height":1600,"width":1600};